import { render, staticRenderFns } from "./PublicFooter.COM.vue?vue&type=template&id=6a388f53"
import script from "./PublicFooter.COM.vue?vue&type=script&lang=js"
export * from "./PublicFooter.COM.vue?vue&type=script&lang=js"
import style0 from "./PublicFooter.COM.vue?vue&type=style&index=0&id=6a388f53&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VContainer,
  VFlex,
  VFooter,
  VLayout,
})
